import { queue_fns } from "@/fp";
import { ref } from "@vue/composition-api";

/* 
// to go from original template to the one with text areas
// get the content from the p
const editables = Array.from(container.querySelectAll('[editable]'))
const create_text_area = (text) =>{
    const el = document.createElement('textarea');
    el.classList.add('textarea')
    el.innerText = text;
    return el;
}
editables.forEach(el =>{
    const content = el.innerText;
    container.replaceChild(create_text_area(content),el);
})

// to go back from textarea to the final template
const text_area_matches_and_parsed  = textareas.map(d => d.innerText.replace(/\n/g,'<br/>'))
const original_template_without_new_lines = original_template.replace(/\n/g,'');
const original_editable_matches = original_template_without_new_lines.match(/(?<=editable="true">).+?(?=<\/p>)/g)
const final_template = original_editable_matches.reduce((acc,c,index)=> acc.replace(c,text_area_matches_and_parsed[index]),original_template_without_new_lines);

*/

/**
 * replacing all contenteditable="true" with textarea
 * */
export const UseHtmlTemplateHandler = (container_selector: string) => {
  let original_template = "";
  let place_holders: Record<string, string> = {};
  const editable_template = ref("");
  const fn_queue_to_run_before_final_template = queue_fns();

  const get_container = () => document.querySelector(container_selector)!;

  const set_placeholders = (
    placeholders: Record<string, string>,
    template: string
  ) => {
    return Object.entries(placeholders).reduce((acc, [k, v]) => {
      return acc.replace(k, v);
    }, template);
  };

  const disable_all_hrefs = () => {
    const all_href_els = get_container().querySelectorAll("[href]");
    all_href_els.forEach((el) => {
      // @ts-ignore
      const prev_val = el!.style.pointerEvents;
      // @ts-ignore
      el!.style.pointerEvents = "none";
      fn_queue_to_run_before_final_template.add(() => {
        // @ts-ignore
        el!.style.pointerEvents = prev_val;
      });
    });
  };

  const parse_editable_sections = () => {
    get_container()
      ?.querySelectorAll("[contenteditable=true]")
      .forEach((el) => {
        el.innerHTML = el.innerHTML
          .replace(/<\/div>/g, "")
          .replace(/<div>/g, "<br/>");
      });
    return get_container().innerHTML;
  };

  const revert_placeholders = (
    placeholders: Record<string, string>,
    template: string
  ) => {
    return Object.entries(placeholders).reduce((acc, [k, v]) => {
      return acc.replace(v, k);
    }, template);
  };

  const get_final_template = () => {
    return create_final_template();
    /*  const new_content = parse_editable_sections();
    fn_queue_to_run_before_final_template.run();
    const email_body = new_content.match(/<div class="email">.+<\/div>/);
    let final_template = "";
    if (email_body && email_body.length > 0) {
      const email_content = email_body[0];
      final_template = original_template.replace(
        /<div class="email">.+<\/div>/,
        revert_placeholders(place_holders, email_content)
      );
    }
    console.log("final_template : ", final_template);
    return final_template; */
  };

  const create_final_template = (): string => {
    const textareas = Array.from(get_container().querySelectorAll("textarea"));
    const text_area_matches_and_parsed = textareas.map((d) =>
      d.value.replace(/\n/g, "<br/>")
    );
    const original_template_without_new_lines = original_template.replace(
      /\n/g,
      ""
    );
    const original_editable_matches = original_template_without_new_lines.match(
      /(?<=contenteditable="true">).+?(?=<\/p>)/g
    )!;
    const final_template = original_editable_matches.reduce(
      (acc, c, index) => acc.replace(c, text_area_matches_and_parsed[index]),
      original_template_without_new_lines
    );
    console.log("final_template : ", final_template);
    return final_template;
  };

  const replace_editable_p_tags_with_textarea = () => {
    const parent = get_container();
    const editables: HTMLParagraphElement[] = Array.from(
      parent.querySelectorAll("[contenteditable]")
    );

    const create_text_area = (text: string) => {
      const el = document.createElement("textarea");
      el.classList.add("text-lg");
      el.classList.add("hover:bg-main-4-hover");
      el.classList.add("resize-none");
      el.classList.add("overflow-y-hidden");
      el.style.fontSize = "inherit";
      el.style.display = "block";
      el.style.width = "100%";
      el.addEventListener("input", function() {
        this.style.height = "0px";
        this.style.height = this.scrollHeight + "px";
      });
      el.innerHTML = text;
      setTimeout(() => {
        el.style.height = el.scrollHeight + "px";
      }, 0);
      return el;
    };

    editables.forEach((el) => {
      const content = el.innerText
        .replace(/<br\/>/g, "\n")
        .replace(/<br>/g, "\n");
      el.parentElement!.replaceChild(create_text_area(content), el);
    });
  };

  const init = (template: string, placeholders: Record<string, string>) => {
    place_holders = placeholders;
    original_template = template;
    editable_template.value = set_placeholders(placeholders, template);
    setTimeout(() => {
      replace_editable_p_tags_with_textarea();
      disable_all_hrefs();
    }, 200);
  };

  return {
    init,
    get_final_template,
    editable_template,
  };
};
